import PropTypes from "prop-types";

export const wizardObjectInterface = {
  id: PropTypes.number, // unique id used on frontend
  name: PropTypes.string,
  description: PropTypes.string,
  enableForVisualizer: PropTypes.bool,
  enableForQuoting: PropTypes.bool,
  featureGroup: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // empty input case
  isFinished: PropTypes.bool, // frontend property
  filterGroups: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    type: PropTypes.string,
    values: PropTypes.array, // not needed
    visualType: PropTypes.string,
  }))
};
